export default "__VITE_ASSET__ef238db2__"